import React, { useState, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import { articlesAPI } from '../services/api';
import ArticleCard from '../components/ArticleCard';

// Category definitions
const categories = [
  { name: 'Business', slug: 'business' },
  { name: 'Technology', slug: 'technology' },
  { name: 'Politics', slug: 'politics' },
  { name: 'International', slug: 'international' },
  { name: 'Sports', slug: 'sports' },
  { name: 'Entertainment', slug: 'entertainment' },
  { name: 'Education', slug: 'education' },
  { name: 'Opinion', slug: 'opinion' }
];

const CategoryPage = () => {
  const { slug } = useParams();
  const [articles, setArticles] = useState([]);
  const [loading, setLoading] = useState(true);
  const category = categories.find(cat => cat.slug === slug);

  useEffect(() => {
    const fetchArticles = async () => {
      try {
        setLoading(true);
        console.log('Fetching articles for category:', slug);
        const data = await articlesAPI.getAll({ category: slug });
        console.log('Received articles:', data);
        setArticles(data);
      } catch (error) {
        console.error('Error fetching articles:', error);
        setArticles([]);
      } finally {
        setLoading(false);
      }
    };

    fetchArticles();
  }, [slug]);

  if (!category) {
    return (
      <div className="max-w-7xl mx-auto px-4 py-16 text-center">
        <h1 className="text-3xl font-bold mb-4">Category Not Found</h1>
        <Link to="/" className="text-blue-600 hover:underline">
          Return to Homepage
        </Link>
      </div>
    );
  }

  const isPositiveCategory = ['youth-sports', 'local-heroes', 'community-events', 'good-deeds'].includes(slug);

  return (
    <div className="max-w-7xl mx-auto px-4 py-8">
      {/* Category Header */}
      <div className="mb-12">
        <h1 className="text-4xl lg:text-5xl font-serif font-bold mb-4">
          {category.name}
        </h1>
        <p className="text-gray-600 text-lg">
          {isPositiveCategory 
            ? `Celebrating ${category.name.toLowerCase()} in the Central Coast community`
            : `Counter-stories and balanced perspectives in ${category.name.toLowerCase()}`
          }
        </p>
      </div>

      {/* Articles Grid */}
      {loading ? (
        <div className="text-center py-16">
          <p className="text-gray-600 text-lg">Loading articles...</p>
        </div>
      ) : articles.length > 0 ? (
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {articles.map((article) => (
            <ArticleCard key={article.id} article={article} />
          ))}
        </div>
      ) : (
        <div className="text-center py-16">
          <p className="text-gray-600 text-lg mb-4">
            No articles in this category yet.
          </p>
          <Link
            to="/"
            className="inline-block px-6 py-3 bg-gray-900 text-white rounded-lg hover:bg-gray-800 transition-colors font-semibold"
          >
            Back to Homepage
          </Link>
        </div>
      )}
    </div>
  );
};

export default CategoryPage;